module.exports = __webpack_public_path__ + "img/Peeling Plating.4c2e0836.png";